<template>
    <section class="team-add-user-view">
        <h3>Add User To Team</h3>
        <app-alert>Adding a user to a team gives them access to view and make modifications to it.</app-alert>
        <label>
            <span class="visuallyhidden">Name or Email</span>
            <app-input 
                v-model="query" 
                placeholder="Name or Email"
                autofocus/>
        </label>
        <div class="students">
            <user-table
                :items="users"
                :columns="['first_name','last_name','email']"
                :allow-sort="false"
                :handle-click="handleAddUser"/>
        </div>
    </section>
</template>
<script>
import User from '@/store/models/User'
import UserTable from '../User/UserTable'

export default {
    name: 'team-add-user-view',
    inject: ['modalOptions'],
    components: {
        UserTable
    },
    props: ['team_id'],
    data() {
        return {
            users: null,
            query: ''
        }
    },
    methods: {
        getUserList(query) {
            this.loading = true
            User.$search(query).then(users => {
                this.loading = false
                this.users = users
            })
        },
        handleAddUser(user) {
            const attachUser = User.query().whereId(user.id).withAll().first()
            attachUser.$attach(this.team_id, 'assignedTeams', 'addUserToTeam')
                .then(() => {
                    this.$emit('reload')
                    this.modalOptions.modalOpen = false
                })
            return false
        }
    },
    watch: {
        query(newValue) {
            this.getUserList(newValue)
        }
    }
}
</script>

<style lang="stylus"></style>
